import Phaser from 'phaser';
import { eventBus, EVENTS } from '../EventBus';
import type { ScreenPayload } from '../types';
import { addBrand, drawCircuitBackdrop } from './sceneArt';

export class LeaderboardScene extends Phaser.Scene {
  constructor() {
    super('LeaderboardScene');
  }

  create(): void {
    drawCircuitBackdrop(this);
    this.add.text(800, 94, 'COMMUNITY HIGH SCORES', {
      fontFamily: 'Arial Black, Arial, sans-serif', fontSize: '58px', color: '#ffffff',
    }).setOrigin(0.5);
    this.add.text(800, 150, 'WHO WILL LIGHT UP THE SUMMIT?', {
      fontFamily: 'Arial, sans-serif', fontSize: '20px', fontStyle: 'bold', color: '#1ed8ff', letterSpacing: 5,
    }).setOrigin(0.5);
    addBrand(this);
    eventBus.emit<ScreenPayload>(EVENTS.screen, { name: 'leaderboard' });
  }
}
